import React from "react";
// import footerImage from "./resources/connect-top-img.jpeg"
import fbImage from "./resources/FACEBOOK link.png"
import twImage from "./resources/TWITTER link.png"
import liImage from "./resources/LINKEDIN link.png"
import ytImage from "./resources/YOUTUBE link.png"

function Footer() {
    return (
        <div className="footer">
            {/* <img src={footerImage} className="footerImage" alt="" /> */}
            <div className="contactLinks">
                <h2 className="footerHeading">Connect With Me</h2>
                <p className="footerText">You can connect with me on social media links below. For all business enquiries you can mail me at <b>leahpk.work@gmail.com</b></p>
                <div className="socialLinks">
                    <a href="https://www.facebook.com/leah.kahn.73/"><img src={fbImage} alt="" /></a>
                    <a href="https://twitter.com/Leahkahn5"><img src={twImage} alt="" /></a>
                    <a href="https://www.linkedin.com/in/leah-khan-080453190/"><img src={liImage} alt="" /></a>
                    <a href="https://www.youtube.com/@canvasofleah"><img src={ytImage} alt="" /></a>
                </div>
            </div>
            <hr />
            <p className="sign">Designed & Coded by Leah</p>
        </div>
    );
};

export default Footer;